import Text12 from '@sdk/components/ui/typography/Text12';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  Container,
  TextContainer,
} from '@web/labor/LaborInformationBox/laborInformationBox.styles';

type Props = {
  summary: {
    noShows: number;
    sickCallouts: number;
  };
};
const AbsenceSummaryInformationBox = ({ summary }: Props) => {
  if (summary.noShows || summary.sickCallouts) {
    // Hint is present until a shift is marked as no show or sick callout once
    return null;
  }

  return (
    <Container pLeft={20} pRight={20} pTop={10} pBottom={10}>
      <TextContainer>
        <Text12 themeColor={ThemeColorType.gray}>
          {gettext(
            'Mark shifts as a sick callout or a no show, when applicable, to be able to monitor employee attendance.'
          )}
        </Text12>
      </TextContainer>
    </Container>
  );
};

export default AbsenceSummaryInformationBox;
